import React, { useEffect, useRef } from 'react';
import Page from '../components/containers/Page';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { indices, projects } from '../data/worklog';
import ImageMedia from '../components/common/ImageMedia';
import useLink from '../hooks/useLink';
// import useProjectPrev from '../hooks/useProjectPrev';
import DynamicProjectLoader from '../projects/DynamicProjectLoader';
import useMouse from '../hooks/useMouse';
import { Button, Logo } from '../components/imports';
import { project } from '../data/data';
import { LetsWork } from './Home';
import { motion } from 'framer-motion';
import animA from '../animations/animA';
import MoveAround from '../components/containers/MoveAround';
import { twMerge } from 'tailwind-merge';

const Work = () => {

  const { projectId } = useParams();
  const navigate = useNavigate();
  const prLink = useLink();


  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/work");
    }
  };

  const currentIndex = projects.findIndex(pr => prLink(pr.client) === projectId);
  const thisProject = projects.find(project => prLink(project.client) === projectId);

  const nextProject = currentIndex < projects.length ? projects[currentIndex + 1] : null;
  const prevProject = currentIndex > 0 ? projects[currentIndex - 1] : null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" })
  }, [])

  // PAGE TITLE
  document.title = `${String(thisProject.client).toUpperCase()} — ${project.website} `


  /* 
    const nextProjects = [
      projects[currentIndex - 1], // Project at currentIndex - 1
      projects[currentIndex + 1], // Project at currentIndex + 1
      projects[currentIndex + 2],  // Project at currentIndex + 2
      projects[currentIndex + 3]  // Project at currentIndex + 2
    ].filter(project => project !== undefined); // Filter out any undefined values
   */


  /*   useEffect(() => {
      console.log(projectId, currentIndex);
      console.log("More Projects", nextProjects);
    }, [projectId, currentIndex, nextProjects]); */


  // NEXT PROJECT ANIMATION
  const nextRef = useRef(null);

  /*  const { scrollYProgress } = useScroll({
    target: nextRef,
    offset: ["center end", "center start"]
  }) */

  // const marginValue = 160;
  // const triggerPoint = .5
  // const marginBottom = useTransform(scrollYProgress, [0, 1], [marginValue * 3, -marginValue * 2])
  // const cardOpacity = useTransform(scrollYProgress, [triggerPoint, 1], [1, .7]);
  // const cardScale = useTransform(scrollYProgress, [triggerPoint, 1], [1, .5]);

  return (

    thisProject &&

    <Page>
      <div className='flex relative h-[75vh] lg:h-[100svh] w-full bg-dark overflow-y-clip'>
        <MoveAround style={{ filter: "sharpness-[2]" }} className='flex center full relative'>
          {/* <DefaultContent /> */}

          <ImageMedia bypass src={require(`../projects/${prLink(thisProject.client)}/${thisProject.metadata.thumbnail}`)} className="dim==========hover:!nodim hover:unmute pointer-events-auto select-none cursor-default muted md:scale-[103%] oneSecond object-cover full" />
        </MoveAround>

        <div className='flex flex-col absolute full bottom-0 py-20 items-end justify-end inset-0 bg-gradient-to-t from-black/90 via-transparent bg-blend-multiply pointer-events-none'>
          <div className='resp flex flex-col lg:items-start justify-between'>
            <div className='flex'>
              <h1 style={{ fontWeight: "450" }} className='capitalize !leading-none tracking-tight drop-shadow-2xl !font-maison'>{thisProject.client}</h1>
            </div>

            <div className='lg:max-w-[60ch] flex flex-col w-full'>

              <div className='inline items-end justify-start gap-2 w-full *:w-fit'>
                {thisProject.metadata.descr && <h5 className='!inline'>{thisProject.metadata.descr}</h5>}
                {thisProject.metadata.year && <h5 className='!inline mr-[3vw]=='>&nbsp;— {thisProject.metadata.year}</h5>}
              </div>
              <div className='w-fit flex gap-2 mt-4'>
                {indices.filter(el => el.client === thisProject.client).map(item =>
                  item.services.map((service, j) => {
                    return (
                      <div key={service + j} className='pointer-events-auto !cursor-default flex px-2 py-1 bg-white/10 rounded *:text-sm hover:bg-white muted hover:text-black hover:unmute quick'>
                        <p>{service}</p>
                      </div>
                    )
                  }))}
              </div>
            </div>
          </div>


        </div>

        {/* NAVIGATE PREV & NEXT PROJECT */}
        {prevProject &&
          <div className='absolute left-0 inset-y-0 bg-white/0 max-lg:portrait:active:bg-white/10 lg:landscape:hover:bg-white/10 w-[50px] md:w-[5vw] cursor-pointer transition group quick'>
            <NavLink to={`/work/${prLink(prevProject.client)}`} className='relative full flex center '>
              <i className='bg-white/20 group-hover:bg-white/0 aspect-square  flex center size-10 rounded-full text-white mix-blend-exclusion  ri-xl ri-arrow-left-s-line ' />
            </NavLink>
          </div>}

        {nextProject &&
          <div className='absolute right-0 inset-y-0 bg-white/0 max-lg:portrait:active:bg-white/10  lg:landscape:hover:bg-white/10 w-[50px] md:w-[5vw] cursor-pointer transition group quick'>
            <NavLink to={`/work/${prLink(nextProject.client)}`} className='relative full flex center '>
              <i className='bg-white/20 group-hover:bg-white/0 aspect-square  flex center size-10 rounded-full text-white mix-blend-exclusion ri-xl ri-arrow-right-s-line ' />
            </NavLink>
          </div>}

      </div>

      {thisProject.locked ?
        // UNAUTHORIZED
        <div className='bg-gradient-to-b from-slate-300 to-slate-200 text-black flex center full relative min-h-[50vh]'>
          <h3 className='space-y-6 resp flex flex-col items-center justify-center'>
            Vous n'êtes pas autorisé à consulter <span className='capitalize'>{thisProject.client}</span>
            <Button variant={"outline"} onClick={handleBack}><i className='ri-xl ri-arrow-left-s-line' /> Retour</Button>
          </h3>
        </div>

        :

        // AUTHORIZED
        <div className='relative flex flex-col items-start justify-start z-[2] bg-dark w-full h-fit '>

          {/* DESCR & CREDITS */}
          <div className='flex flex-col resp gap-16= divide-y-1 divide-gray-500'>
            {thisProject.metadata.overview &&
              <div className='w-full text-slate-200 py-24 group'>
                <div className='resp= grid grid-cols-1 justify-between flex-col lg:flex-row items-start '>
                  <div className=' w-full relative flex flex-col'>
                    <div className='flexResp items-start justify-start w-fit gap-6'>
                      <h4 className='group-hover:dim=== quick w-[20ch]'>Le projet</h4>
                      <h5 className='font-light maxW mx-auto text-left select-none font-poppins dim group-hover:nodim group-hover:text-white quick '>{thisProject.metadata.overview}</h5>
                    </div>
                  </div>
                </div>
              </div>
            }

            {/* DELIVERABLES */}
            {thisProject.delivrables &&
              <div className='w-full text-slate-200 group'>
                <div className='resp= grid grid-cols-1 justify-between flex-col lg:flex-row items-start '>
                  <div className='w-full relative flex flex-col'>
                    <div className='flexResp items-start justify-start w-fit gap-6'>
                      <h5 className='quick w-[20ch]'>Livrables</h5>
                      <div className='font-light maxW= mx-auto text-left font-poppins dim group-hover:nodim group-hover:text-white quick flex flex-col gap-6 '>
                        {thisProject.delivrables.map((element, i) => {
                          return (
                            <li key={element + i} className='relative'>
                              <h5>
                                <span className='-left-5 absolute top-0 text-primary'>+&nbsp;</span>{element.section}
                              </h5>
                              <ul className=''>
                                {element.items.map((item, j) => {
                                  return (
                                    <h5 key={item + j} className='flex '>
                                      <span className='flex'>—</span><span className='ml-3 block'>{item.label}</span>
                                    </h5>
                                  )
                                })}
                              </ul>
                            </li>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>


          {/* DYNAMICALLY IMPORTED PROJECT DATA */}
          <DynamicProjectLoader />


          {/* PROJECT CREDITS */}
          {thisProject.metadata.credits &&
            <div className='w-full relative block z-[2] py-40 bg-black'>
              <div className='resp flex flex-col items-center justify-center w-full gap-4 text-white font-mono'>
                <h4>Crédits</h4>
                <div className='flex flex-col w-full items-center justify-center relative mx-auto '>
                  {thisProject.metadata.credits.map((credit, i) => {
                    return (
                      <div key={i} className='flex flex-row items-start w-full gap-6 dim1'>
                        <h5 className='w-1/2 text-right '>{credit.title}</h5>
                        <h5 className='w-1/2 text-left'>{credit.by === "us" ? <Logo src={"white"} className={"mr-auto max-h-3 mt-1.5 lg:mt-2.5"} /> : credit.by}</h5>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          }

          <div ref={nextRef} className='relative flex flex-col items-center justify-start w-full overflow-y-clip '>
            <div className='bg-gradient-to-t from-neutral-950 to-dark h-[120%] absolute bottom-0 z-[0]  inset-x-0' />

            {nextProject &&
              <NextProject
                nextProject={nextProject}
              />
            }

          </div>
        </div>
      }

      {!nextProject &&

        <>
          <OtherProjects thisProject={thisProject} />
          <div className='flex h-[30vh]' />
          <LetsWork />
        </>
      }


    </Page>

  )
}

const NextProject = ({ nextProject, marginBottom, cardOpacity /* , cardScale */ }) => {
  const prLink = useLink()
  const { toDefault, toSee } = useMouse();
  const { ease, duration } = animA();

  return (
    <motion.div
      style={{
        marginBottom,
        opacity: cardOpacity,
        // scale: cardScale
      }}
      // whileHover={{opacity: .6}}
      transition={{ ease, duration }}
      className='resp flex !h-[70%] min-h-[500px] mx-auto my-40 bg-dark border border1 z-[2] w-[85%] md:aspect-video relative group scale-[97%] hover:scale-[105%] max-md:rounded-xl quick overflow-clip'>


      <NavLink to={`/work/${prLink(nextProject.client)}`} onMouseEnter={toSee} onMouseLeave={toDefault} className='relative= flex full overflow-y-clip'>
        <div className='bg-gradient-to-b from-dark/50 absolute top-0 inset-x-0 h-[30%] scale-110 !z-[1]' />
        <ImageMedia /* bypass */
          src={require(`../projects/${prLink(nextProject.client)}/${nextProject.metadata.thumbnail || ("_cover.jpg" || "_cover.png")}`)}
          className={`${nextProject.metadata.css} absolute pointer-events-none select-none inset-0 full scale-[102%] group-hover:nodim group-hover:unmute group-hover:scale-[105%] quick`}
        />
        <div className='resp relative paddingY !z-[2]'>
          <div className="relative flex flex-col items-start w-fit">
            <h5 className='font-light uppercase text-white'>Voir projet suivant</h5>
            {/* <i className='z-[2] group-hover:translate-x-[25%] oneSecond my-auto absolute -right-4 ri-xl ri-arrow-down-s-line' /> */}
            {/* &nbsp;|&nbsp;  */}
            <h1 className='flex capitalize max-w-[15ch] font-medium leading-none tracking-tight origin-top-left scale-90 group-hover:scale-100= quick'>{nextProject.client}</h1>
          </div>
        </div>
      </NavLink>
    </motion.div>
  )
}


export const OtherProjects = ({ thisProject, prev }) => {

  const prLink = useLink();
  const { toScroll, toDefault } = useMouse();

  return (
    <div className={twMerge('relative flex flex-col w-fit items-start gap-10 resp= justify-start paddingY', !prev && "mt-40 mb-20")}>

      {!prev &&
        <h3 id="buttonUnderline2" className='absolute= mb-6 relative nowrap p-2 z-[4] border border1 mx-auto uppercase -translate-y-16====='>Index de projets</h3>
      }

      {!prev &&
        <>
          <div className='absolute z-[1] !bottom-0  lg:right-0 lg:inset-y-0 w-full lg:w-[300px] max-sm:h-[200px] bg-gradient-to-t lg:bg-gradient-to-l from-dark pointer-events-none ' />
          <div className='absolute z-[3] !top-0 lg:left-0 lg:inset-y-0 w-full lg:w-[300px] max-sm:h-[200px] bg-gradient-to-b lg:bg-gradient-to-r from-dark pointer-events-none ' />
        </>
      }

      <div onMouseEnter={toScroll} onMouseLeave={toDefault} className={twMerge('flex w-fit items-center scrollbar-hide', !prev && " flex-col lg:flex-row overflow-scroll max-md:pt-[20vh] w-full")}>
        <div className={twMerge('flex gap-4 lg:gap-8 w-fit===h-fit lg:py-10', !prev && "flex-col lg:flex-row items-start  px-64")}>
          {projects.filter(pr => prLink(pr.client) !== thisProject).map((other, i) => {
            const TextSize = !prev ? "h2" : "h2"
            return (
              <NavLink to={`/work/${prLink(other.client)}`} key={other.client} className='muted hover:unmute quick flex whitespace-nowrap'>
                <TextSize className='capitalize'>{other.client}</TextSize>
                <p className='muted text-sm capitalize'>{other.metadata.year}</p>
              </NavLink>
            )
          })}
        </div>
      </div>
    </div>
  )
}


export default Work
